import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"error\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20 32.25c6.904 0 12.5-5.596 12.5-12.5S26.904 7.25 20 7.25 7.5 12.846 7.5 19.75s5.596 12.5 12.5 12.5Zm0 1.5c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14Zm1.05-12.499a1.051 1.051 0 0 1-2.1 0l-.375-7.503a1.427 1.427 0 1 1 2.85 0l-.375 7.503ZM20 24.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol